(() => {
  // Galería de producto: cambia la imagen principal al tocar una miniatura
  document.querySelectorAll('[data-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const img = document.querySelector('[data-main-media] img');
      if (!img) return;
      img.removeAttribute('srcset');
      img.src = btn.dataset.thumb;
      document.querySelectorAll('[data-thumb]').forEach((b) => b.removeAttribute('aria-current'));
      btn.setAttribute('aria-current', 'true');
    });
  });

  // Variantes: actualiza precio, precio anterior y botón
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const scope = select.closest('[data-product]');
    const price = scope.querySelector('[data-price]');
    const compare = scope.querySelector('[data-compare]');
    const button = scope.querySelector('[data-add-button]');
    const label = button ? button.dataset.label : '';
    const update = () => {
      const opt = select.selectedOptions[0];
      if (price) price.textContent = opt.dataset.price;
      if (compare) {
        compare.textContent = opt.dataset.compare || '';
        compare.hidden = !opt.dataset.compare;
      }
      if (button) {
        const available = opt.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? label : 'Agotado';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    };
    select.addEventListener('change', update);
  });

  // Botones de cantidad
  document.querySelectorAll('[data-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
      input.value = next;
    });
  });

  // Orden de colección: envía el formulario al cambiar
  document.querySelectorAll('[data-autosubmit]').forEach((el) => {
    el.addEventListener('change', () => el.form.submit());
  });

  // Cierra el menú móvil al pulsar Escape
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details.mobile-nav[open]').forEach((d) => {
      d.removeAttribute('open');
      d.querySelector('summary').focus();
    });
  });
})();

(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Barra de anuncios: rota los mensajes cada 5 s (se detiene al pasar el mouse)
  document.querySelectorAll('[data-announcement]').forEach((bar) => {
    const items = [...bar.querySelectorAll('.announcement__item')];
    if (items.length < 2 || reduceMotion) {
      if (reduceMotion) items.forEach((i) => (i.hidden = false));
      bar.classList.toggle('announcement--static', reduceMotion);
      return;
    }
    let i = 0;
    let paused = false;
    bar.addEventListener('mouseenter', () => (paused = true));
    bar.addEventListener('mouseleave', () => (paused = false));
    bar.addEventListener('focusin', () => (paused = true));
    bar.addEventListener('focusout', () => (paused = false));
    setInterval(() => {
      if (paused) return;
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
    }, 5000);
  });

  // Carruseles de productos
  document.querySelectorAll('[data-carousel]').forEach((wrap) => {
    const track = wrap.querySelector('[data-carousel-track]');
    const prev = wrap.querySelector('[data-carousel-prev]');
    const next = wrap.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;
    const step = () => track.clientWidth * 0.85;
    const sync = () => {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  // Desplegables del menú: cierra los demás y al hacer clic fuera
  const dropdowns = [...document.querySelectorAll('details.dropdown')];
  dropdowns.forEach((d) => d.addEventListener('toggle', () => {
    if (d.open) dropdowns.forEach((o) => o !== d && o.removeAttribute('open'));
  }));
  document.addEventListener('click', (e) => {
    dropdowns.forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  // Agregar al carrito sin salir de la página
  const toast = document.querySelector('[data-toast]');
  const toastText = toast && toast.querySelector('[data-toast-text]');
  let toastTimer;
  const showToast = (msg, isError) => {
    if (!toast) return;
    toastText.textContent = msg;
    toast.classList.toggle('toast--error', !!isError);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (toast.hidden = true), 4500);
  };
  const routes = window.themeRoutes || { cartAdd: '/cart/add.js', cart: '/cart.js' };

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add$/.test(form.getAttribute('action') || '')) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Agregando…'; }
    try {
      const res = await fetch(routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'No se pudo agregar este producto.');
      const cart = await (await fetch(routes.cart, { headers: { Accept: 'application/json' } })).json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      showToast(`Agregado: ${data.product_title || 'producto'}`);
    } catch (err) {
      showToast(err.message, true);
    } finally {
      if (button) { button.disabled = false; button.textContent = original; }
    }
  });

  // Productos relacionados
  document.querySelectorAll('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (_) { /* sin recomendaciones */ }
  });
})();
